<template>
  <div id="upload-file-component">
    <b-row>
      <b-col cols="12">
        <b-row
          class="p-1 d-flex justify-content-center align-items-center border-outer bg-white"
        >
          <b-col
            class="d-flex justify-content-center align-items-center"
            cols="12"
          >
            <div class="content-wrp m-1">
              <img
                v-if="!csvFile"
                :src="activeIcon || IconCSVInActive"
                width="60"
                height="60"
              />
              <img
                v-else
                :src="inactiveIcon || IconCSVActive"
                width="60"
                height="60"
              />
            </div>
          </b-col>
          <b-col
            class="d-flex justify-content-center align-items-center"
            cols="12"
          >
            <div
              class="content-wrp m-1 d-flex justify-content-center align-items-center"
            >
              <div class="d-flex justify-content-center align-items-center inactive-wrp" v-if="!csvFile">
                <div>
                  <b-form-file
                    v-model="csvFile"
                    ref="fileInput"
                    class="d-none"
                    plain
                    :accept="acceptFile.toString()"
                    @input="onInputFile"
                  ></b-form-file>
                  <b-button
                    class="btn-color-primary font-medium-4"
                    @click="onUploadFile"
                    >Upload File</b-button
                  >
                </div>
                <div class="mx-1 font-medium-4">Or</div>
                <div>
                  <b-link
                    class="font-medium-4 text-success underline"
                    @click="onDownloadTemplate"
                    >Download Template</b-link
                  >
                </div>
              </div>
              <div class="d-flex align-items-stretch acctive-wrp" v-else>
                <div class="d-flex align-self-center mr-1">
                  <div class="font-medium-4 text-bold">
                    {{ csvFile ? onResolveFileName(csvFile.name) : "" }}
                  </div>
                </div>
                <div class="d-flex align-self-center ml-1">
                  <b-button
                    variant="outline-danger"
                    class="btn-icon rounded-circle btn-xxs"
                    @click="onResetFile"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
  watch,
  computed,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

import IconCSVActive from "@/assets/images/pages/upload-file/IconCSVActive.png";
import IconCSVInActive from "@/assets/images/pages/upload-file/IconCSVInActive.png";

export default {
  props: {
    file: { type: [Object, File], default: () => null },
    templateUrl: { type: String, default: null },
    acceptFile: {
      type: [String, Array],
      default: () => [".csv", ".xls", ".xlsx"],
    },
    activeIcon: { type: String, default: null },
    inactiveIcon: { type: String, default: null },
  },
  setup(props) {
    const { openErrorModal } = useValidationModal();

    const vm = getCurrentInstance().proxy;
    const csvFile = ref(null);

    const onResolveFileName = (fileName) => {
      if (fileName && fileName.length >= 30) {
        return fileName.substr(1, 30) + "...";
      } else {
        return fileName;
      }
    };

    const onResolveAcceptFileArray = (acceptFile) => {
      if (typeof acceptFile == "string") {
        return acceptFile.split(" ");
      } else if (typeof acceptFile == "object") {
        return acceptFile;
      } else {
        console.error("invalid accept file");
        return;
      }
    };

    const onInputFile = (file) => {
      if (!file) return;

      const _validFileExtensions = onResolveAcceptFileArray(props.acceptFile);

      const fileName = file.name;
      if (fileName.length > 0) {
        var isValidExtension = false;
        var fileExtension = null;

        for (var i = 0; i < _validFileExtensions.length; i++) {
          var curExtension = _validFileExtensions[i];
          fileExtension = fileName
            .substr(fileName.length - curExtension.length, curExtension.length)
            .toLowerCase();

          if (fileExtension == curExtension.toLowerCase()) {
            isValidExtension = true;
            csvFile.value = file;
            onChangeFileValue(file);
            break;
          }
        }

        if (!isValidExtension) {
          openErrorModal(
            "อัพโหลดไฟล์ไม่ถูกต้อง",
            "<div>กรุณาอัพโหลดไฟล์ใหม่อีกครั้ง</div>" +
              "<div class='text-bold'>นามสกุลไฟล์ที่รองรับ " +
              _validFileExtensions.join(", ") +
              "</div>",
            "ปิด"
          );
          onChangeFileValue(null);
          return (csvFile.value = null);
        }
      }
    };

    const onUploadFile = (e) => {
      e.preventDefault();
      vm.$refs.fileInput.$el.click();
    };

    const onDownloadTemplate = (e) => {
      e.preventDefault();
      if (props.templateUrl) window.location.href = props.templateUrl;
    };

    const onResetFile = (e) => {
      e.preventDefault();
      csvFile.value = null;
      onChangeFileValue(null);
    };

    const onChangeFileValue = (file) => {
      vm.$emit("onInputFile", file);
    };

    onBeforeMount(() => {
      if (props.file) csvFile.value = props.file;
    });

    return {
      IconCSVActive,
      IconCSVInActive,

      csvFile,
      onInputFile,
      onUploadFile,
      onDownloadTemplate,
      onResetFile,
      onResolveFileName,
    };
  },
};
</script>

<style scoped>
#upload-file-component .border-outer {
  border-radius: 0.5rem !important;
  border: 2px dashed #90a1b9 !important;
}

#upload-file-component .btn-color-primary {
  background-color: #007fff !important;
  border-color: #007fff !important;
}

#upload-file-component .text-success {
  color: #328300 !important;
}

#upload-file-component .underline {
  text-decoration: underline;
}

#upload-file-component .text-overflow {
  white-space: nowrap;
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
